<template>
  <div class="text-left">
    <h5 v-if="supervisor" class="text-center"><strong>{{ $t("supervisor") }}:</strong> {{ supervisor.username }}</h5>
    <v-divider />
    <v-card class="mt-4 pa-6">
      <IndustrialPropertyFields :industrial-property="item" readonly />
      <v-divider class="mt-6 mb-5" />
      <IndustrialPropertyFiles :id="operationId" readonly />
      <v-divider />
      <DirectorActions v-if="isAuthorize" object_type="industrial_property" class="text-center" />
      <SupervisorActions
        v-else
        :item="item"
        object_type="industrial_property"
        :form_name="formName"
        :state="state"
        :supervisor="supervisor ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import DirectorActions from "@/components/action_buttons/DirectorActions";
import IndustrialPropertyFields from "@/components/industrialProperty/IndustrialPropertyFields.vue";
import IndustrialPropertyFiles from "@/components/industrialProperty/IndustrialPropertyFiles.vue";
import SupervisorActions from "@/components/action_buttons/SupervisorActions";
import { createDefaultIndustrialProperty, normalizeIndustrialProperty } from "@/utils/industrialProperty";

export default {
  name: "ReviewIndustrialPropertyForms",
  components: { DirectorActions, IndustrialPropertyFields, IndustrialPropertyFiles, SupervisorActions },
  data: () => ({
    item: createDefaultIndustrialProperty(), operationId: null, formName: "", state: "", supervisor: null
  }),
  computed: { isAuthorize() { return this.$route.meta.authorize !== undefined; } },
  created() {
    axios.get(`${this.$store.state.endpoint}/moderatedOperations/review/industrial_property/${this.$route.params.id}`)
      .then(response => {
        this.operationId = response.data.id;
        this.item = normalizeIndustrialProperty(response.data.data.user.industrial_property);
        this.formName = response.data.form_name;
        this.state = response.data.state;
        this.supervisor = response.data.supervisor;
      }).catch(error => console.error(error));
  },
  methods: {
    onStateSupervisorChange(state, supervisor) { this.state = state; this.supervisor = supervisor; }
  }
};
</script>
